module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.a43f02ce.jpeg";